import { useToast } from 'primevue/usetoast';

export function useFollowNotification() {
  const toast = useToast();

  return (severity, type, followerName, negative) => {
    let detailMessage = '';

    if (severity === 'success') {
      if (type === 'followed') {
        detailMessage = `You have successfully followed this user ${
          negative ? 'skeptically' : 'as a fan'
        }. Their posts will now appear in your For you (${negative ? 'skeptic' : 'fan'}) feed.`;
      } else if (type === 'unfollowed') {
        detailMessage = `You have successfully unfollowed this user ${
          negative ? 'as a skeptical follower' : 'as a fan'
        }. You will no longer see their posts in your For you (${negative ? 'skeptic' : 'fan'}) feed.`;
      }
    } else {
      if (type === 'followed') {
        detailMessage = `An error occurred while trying to follow this user ${
          negative ? 'as a skeptical follower' : 'as a fan'
        }. Please try again later.`;
      } else if (type === 'unfollowed') {
        detailMessage = `An error occurred while trying to unfollow this user ${
          negative ? 'as a skeptical follower' : 'as a fan'
        }. Please try again later.`;
      }
    }

    toast.add({
      severity: severity,
      summary: severity === 'success' ? 'Success' : 'Error',
      detail: detailMessage,
      life: 5000,
    });
  };
}
